import _ from "lodash";
import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { CHAT_SCREEN_MODE } from "Utils/MessageHelpers";

const MessageOptionsContext = createContext({});

const MessageOptionsProvider = props => {
  const {
    children,
    chatId,
    conversationId,
    screenMode,
    activeUserId,
    isPreviewMessagesModal,
    defaultNameSortPreference,
    defaultStudentNameOrderPreference,
    currentUserType,
    curriculumProgramType,
  } = props;

  const value = useMemo(
    () => ({
      chatId,
      conversationId,
      parentKey: chatId ? "chatId" : "conversationId",
      screenMode,
      activeUserId,
      isPreviewMessagesModal,
      defaultNameSortPreference,
      defaultStudentNameOrderPreference,
      currentUserType,
      curriculumProgramType,
    }),
    [
      chatId,
      screenMode,
      activeUserId,
      isPreviewMessagesModal,
      conversationId,
      defaultNameSortPreference,
      defaultStudentNameOrderPreference,
      currentUserType,
      curriculumProgramType,
    ]
  );

  return (
    <MessageOptionsContext.Provider value={value}>
      {children}
    </MessageOptionsContext.Provider>
  );
};

MessageOptionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  chatId: PropTypes.string,
  conversationId: PropTypes.string,
  isPreviewMessagesModal: PropTypes.bool,
  screenMode: PropTypes.oneOf(_.values(CHAT_SCREEN_MODE)).isRequired,
};

MessageOptionsProvider.defaultProps = {
  isPreviewMessagesModal: false,
  chatId: null,
  conversationId: null,
};

const useMessageOptions = () => {
  const context = useContext(MessageOptionsContext);
  return context;
};

export { useMessageOptions };
export default MessageOptionsProvider;
